import useAuthorization from '../../../hooks/useAuthorization';
import React, { FC } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Spinner from '../../atoms/Spinner/Spinner';

interface LandingPageProps {}

const LandingPage: FC<LandingPageProps> = () => {
  const { isAuthorized: isBuyerManager, status } = useAuthorization({
    requiredRoles: ['BuyerManager'],
  });

  const currentLocation = useLocation();

  if (status === 'idle' || status === 'loading') {
    return <Spinner />;
  }

  return (
    <>
      {isBuyerManager ? (
        <Navigate
          to="/organizations"
          state={{ from: currentLocation }}
          replace
        />
      ) : (
        <Navigate to="/landscapes" state={{ from: currentLocation }} replace />
      )}
    </>
  );
};

export default LandingPage;
